module.exports = __webpack_public_path__ + "static/christmas.872c32d6.png";


//////////////////
// WEBPACK FOOTER
// ./public/static/christmas.png
// module id = 442
// module chunks = 168707334958949